<div wproTrapFocus class="fdx-c-modal">
    <div class="fdx-c-modal__backdrop"></div>
    <div class="fdx-c-modal__main fdx-c-modal__main--medium fdx-c-modal__main--small@small-only">
        <div class="fdx-c-modal__body fdx-u-align--center">
            <h3 id="leaveWithoutSaveTitle" class="fdx-c-header--h4 fdx-u-mt--4">
                {{ 'editScreenConfirmation.continueWithoutSaveTitle'| translate }}
            </h3>
            <div id="leaveWithoutSaveMessage" class="fdx-u-my--7 fdx-u-ml--10  fdx-o-grid__item--10@small-only fdx-u-ml--6@small-only fdx-o-grid__item--10">
                <h2 class="fdx-c-header fdx-u-fontsize--default" id="singleDeviceSubtitle">
                    {{ 'editScreenConfirmation.continueWithoutSaveMessage'| translate }}
                </h2>
            </div>
            <!-- Continue button -->
            <div class="fdx-o-layout-grid fdx-o-layout-grid--center">
                <button id="continueBtn" type="submit" class="fdx-c-button fdx-c-button--primary" aria-atomic="true"
                    aria-live="assertive" (click)="continueClicked()">
                    {{ 'editScreenConfirmation.continueBtn' | translate }}
                </button>
            </div>
            <!-- Cancel button -->
            <div class="fdx-o-layout-grid fdx-o-layout-grid--center fdx-u-mb--4 fdx-u-mt--1">
                <button id="cancelBtn"
                    class="fdx-c-button fdx-c-button--suffix fdx-c-button--text fdx-c-button--responsive fdx-u-cursor--pointer fdx-u-align--center"
                    aria-atomic="true" aria-live="assertive" (click)="closePopup()">
                    {{'editScreenConfirmation.cancelBtn' | translate }}
                </button>
            </div>
        </div>
        <div class="fdx-c-modal__footer">
            <button class="fdx-c-modal__footer__button fdx-c-button fdx-c-button--icon" (click)="closePopup()">
                <div>
                  <ciam-icon class="fdx-c-icon" aria-hidden="true" key="cross"></ciam-icon>
                </div>
            </button>
        </div>
    </div>
</div>
